import React from 'react';
import { CheckIcon, CreditCardIcon, ShieldCheckIcon, ZapIcon, StarIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-gradient-to-b from-[#141418] to-[#111116] py-8 md:py-16 px-4" data-id="element-206">
      <div className="max-w-5xl mx-auto" data-id="element-207">
        {/* Encabezado: Realidad del oficio */}
        <div className="text-center mb-6 md:mb-12 max-w-2xl mx-auto" data-id="element-208">
          <h2 className="text-xl md:text-4xl font-black text-white leading-tight mb-2" data-id="element-209">
            La barbería no es una moda.
          </h2>
          <p className="text-lg md:text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#ef5350] to-[#ff7043] mb-4" data-id="element-210">
            Es un oficio con demanda constante.
          </p>

          <div className="bg-[#1a1a22] border border-white/10 rounded-xl p-3 md:p-5 mb-4" data-id="element-211">
            <p className="text-gray-300 text-xs md:text-base leading-relaxed" data-id="element-212">
              En muchas ciudades de Argentina, un corte puede cobrarse entre{' '}
              <strong className="text-white bg-[#e53935]/20 px-2 py-0.5 rounded" data-id="element-213">
                $10.000 y $20.000
              </strong>{' '}
              dependiendo del nivel y la zona.
            </p>
          </div>

          <p className="text-gray-400 text-xs md:text-base leading-relaxed mb-1" data-id="element-214">
            La diferencia entre un corte común y un corte profesional está en la
            técnica.
          </p>
          <p className="text-white font-black text-sm md:text-lg" data-id="element-215">
            Elegí el plan para empezar hoy mismo.
          </p>
        </div>

        {/* Grid de Precios */}
        <div className="grid grid-cols-2 gap-3 md:gap-6 lg:gap-10 items-start mb-8" data-id="element-216">
          {/* Tarjeta 1: Pack Base */}
          <div className="bg-[#1a1a22] rounded-xl md:rounded-2xl border border-white/10 shadow-xl overflow-hidden flex flex-col h-full" data-id="element-217">
            <div className="bg-white/5 border-b border-white/10 p-3 md:p-6 text-center relative" data-id="element-218">
              <h3 className="text-sm md:text-2xl font-black text-white mb-1 md:mb-2" data-id="element-219">
                Pack Base
              </h3>
              <p className="text-gray-400 text-[10px] md:text-sm font-semibold mb-3 md:mb-6" data-id="element-220">
                Formación en Barbería
              </p>

              <div className="mb-0.5" data-id="element-221">
                <span className="text-xs md:text-xl text-gray-500 line-through font-bold" data-id="element-222">
                  $49.990
                </span>
              </div>
              <div className="flex items-baseline justify-center gap-1 mb-2" data-id="element-223">
                <span className="text-2xl md:text-5xl font-black text-white" data-id="element-224">
                  $19.990
                </span>
                <span className="text-xs md:text-xl text-gray-400 font-bold" data-id="element-225">
                  ARS
                </span>
              </div>
            </div>

            <div className="p-3 md:p-6 space-y-2 md:space-y-3 flex-grow" data-id="element-226">
              <p className="text-[9px] md:text-sm text-gray-400 font-black tracking-widest uppercase mb-2 md:mb-4" data-id="element-227">
                Incluye:
              </p>
              {['Acceso inmediato', 'Clases en video', 'Manual (PDF)', '3 Bonus', 'Certificado'].map(text => <div key={text} className="flex items-start gap-1.5 md:gap-3 text-gray-300" data-id="element-228">
                  <CheckIcon className="w-3 h-3 md:w-5 md:h-5 text-[#ef5350] flex-shrink-0 mt-0.5" data-id="element-229" />
                  <span className="text-[10px] md:text-base font-semibold leading-tight" data-id="element-230">
                    {text}
                  </span>
                </div>)}
            </div>

            <div className="p-3 md:p-6 pt-0 mt-auto" data-id="element-231">
              <a href="https://checkout.tuvidasimple.shop/cart/44818129059942:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-white/10 hover:bg-white/20 text-white font-black text-[10px] md:text-lg py-2.5 md:py-4 rounded-lg md:rounded-xl text-center transition-colors border border-white/20" aria-label="Acceder al Pack Base" data-id="element-232">
                PACK BASE
              </a>
            </div>
          </div>

          {/* Tarjeta 2: Pack Completo (Más Elegido) */}
          <div className="bg-[#1a1a22] rounded-xl md:rounded-2xl border-2 border-[#e53935] shadow-[0_0_30px_rgba(229,57,53,0.15)] overflow-hidden flex flex-col h-full relative" data-id="element-233">
            {/* Cinta de urgencia - solo desktop */}
            <div className="hidden md:block absolute top-7 -right-14 w-56 bg-gradient-to-r from-[#e53935] to-[#ef5350] text-white text-[10px] md:text-xs font-black uppercase tracking-widest py-1.5 text-center rotate-45 shadow-lg z-20" data-id="element-234">
              Cupos limitados
            </div>

            <div className="bg-gradient-to-r from-[#e53935] to-[#ef5350] py-1 md:py-2 text-center" data-id="element-235">
              <p className="text-white text-[9px] md:text-sm font-black tracking-widest uppercase flex items-center justify-center gap-0.5 md:gap-1 animate-pulse" data-id="element-236">
                <StarIcon className="w-2.5 h-2.5 md:w-4 md:h-4 fill-white" data-id="element-237" />{' '}
                MÁS ELEGIDO
              </p>
            </div>

            <div className="bg-gradient-to-br from-[#e53935]/10 to-[#ff7043]/5 border-b border-[#e53935]/20 p-3 md:p-6 text-center relative" data-id="element-238">
              <h3 className="text-sm md:text-2xl font-black text-white mb-1 md:mb-2" data-id="element-239">
                Pack Completo
              </h3>
              <p className="text-gray-400 text-[10px] md:text-sm font-semibold mb-3 md:mb-6" data-id="element-240">
                Barbería + Colorimetría
              </p>

              <div className="mb-0.5" data-id="element-241">
                <span className="text-xs md:text-xl text-gray-500 line-through font-bold" data-id="element-242">
                  $76.980
                </span>
              </div>
              <div className="flex items-baseline justify-center gap-1 mb-2" data-id="element-243">
                <span className="text-2xl md:text-6xl font-black text-white" data-id="element-244">
                  $26.990
                </span>
                <span className="text-xs md:text-2xl text-gray-400 font-bold" data-id="element-245">
                  ARS
                </span>
              </div>

              <p className="text-[#25D366] text-[9px] md:text-sm font-bold bg-[#25D366]/10 inline-block px-2 md:px-3 py-1 md:py-1.5 rounded-lg mt-1 md:mt-2" data-id="element-246">
                Recuperás con 2 cortes
              </p>
            </div>

            <div className="p-3 md:p-6 space-y-2 md:space-y-3 flex-grow" data-id="element-247">
              <p className="text-[9px] md:text-sm text-gray-400 font-black tracking-widest uppercase mb-2 md:mb-4" data-id="element-248">
                Todo lo del base, MÁS:
              </p>
              {['Acceso inmediato', 'Clases en video', 'Manual (PDF)', '3 Bonus', 'Certificado'].map(text => <div key={text} className="flex items-start gap-1.5 md:gap-3 text-gray-400" data-id="element-249">
                  <CheckIcon className="w-3 h-3 md:w-5 md:h-5 text-gray-600 flex-shrink-0 mt-0.5" data-id="element-250" />
                  <span className="text-[10px] md:text-base font-medium leading-tight" data-id="element-251">
                    {text}
                  </span>
                </div>)}

              <div className="w-full h-px bg-white/10 my-2 md:my-4" data-id="element-252"></div>

              <div className="flex items-start gap-1.5 md:gap-3 text-white bg-[#e53935]/10 p-2 md:p-3 rounded-lg border border-[#e53935]/20" data-id="element-253">
                <ZapIcon className="w-3.5 h-3.5 md:w-6 md:h-6 text-[#ef5350] flex-shrink-0 mt-0.5" data-id="element-254" />
                <span className="text-[10px] md:text-base font-black leading-tight" data-id="element-255">
                  Colorimetría completa
                </span>
              </div>
            </div>

            <div className="p-3 md:p-6 pt-0 mt-auto" data-id="element-256">
              <a href="https://checkout.tuvidasimple.shop/cart/44818150719590:1" target="_blank" rel="noopener noreferrer" className="cta-primary block w-full text-white font-black text-[11px] md:text-xl py-2.5 md:py-5 rounded-lg md:rounded-xl text-center shadow-xl" aria-label="Acceder al Pack Completo" data-id="element-257">
                👉 PACK COMPLETO
              </a>
            </div>
          </div>
        </div>

        {/* Elementos de confianza inferiores */}
        <div className="max-w-xl mx-auto" data-id="element-258">
          <p className="text-gray-500 text-[10px] md:text-xs text-center mb-3 md:mb-5 font-semibold" data-id="element-259">
            Acceso inmediato después del pago.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-gray-500 text-[9px] md:text-xs mb-4 md:mb-8" data-id="element-260">
            <div className="flex items-center gap-1" data-id="element-261">
              <CreditCardIcon className="w-3 h-3 md:w-4 md:h-4" data-id="element-262" />
              <span data-id="element-263">Mercado Pago</span>
            </div>
            <span className="hidden md:inline" data-id="element-264">·</span>
            <div className="flex items-center gap-1" data-id="element-265">
              <ShieldCheckIcon className="w-3 h-3 md:w-4 md:h-4" data-id="element-266" />
              <span data-id="element-267">Compra segura</span>
            </div>
            <span className="hidden md:inline" data-id="element-268">·</span>
            <div className="flex items-center gap-1" data-id="element-269">
              <ZapIcon className="w-3 h-3 md:w-4 md:h-4" data-id="element-270" />
              <span data-id="element-271">Acceso inmediato</span>
            </div>
          </div>

          {/* Soporte WhatsApp */}
          <a href="https://wa.link/w7hdgn" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-[#25D366]/10 border border-[#25D366]/30 hover:border-[#25D366] rounded-lg md:rounded-xl px-3 md:px-4 py-2 md:py-3 transition-all mb-4 md:mb-6 no-underline group" data-id="element-272">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 md:w-5 md:h-5 text-[#25D366] flex-shrink-0" aria-hidden="true" data-id="element-273">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-274" />
            </svg>
            <span className="text-[#25D366] text-[10px] md:text-sm font-semibold group-hover:text-[#1ebe5d] transition-colors" data-id="element-275">
              💬 ¿Problema con el pago? Escribinos
            </span>
          </a>

          {/* Disclaimer producto digital */}
          <p className="text-gray-600 text-[9px] md:text-[11px] text-center leading-relaxed" data-id="element-276">
            Producto digital – acceso inmediato.
            <br data-id="element-277" />
            El acceso se envía automáticamente por email luego del pago.
            <br data-id="element-278" />
            No se envían productos físicos.
          </p>
        </div>
      </div>
    </section>;
}